import { render } from "./App.vue?vue&type=template&id=7f9bd8b0&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=7f9bd8b0&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=7f9bd8b0&lang=scss"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9bd8b0"]])

export default __exports__